import axios from 'axios';
import config from '../config';

// Separate axios instance for super admin API (different base path)
const instance = axios.create({
  baseURL: config.superAdminApiUrl,
});

instance.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // If we have an impersonation token saved, restore it instead of logging out
      const impersonationToken = sessionStorage.getItem('impersonationToken');
      if (impersonationToken) {
        sessionStorage.setItem('token', impersonationToken);
        const impersonationUser = sessionStorage.getItem('impersonationUser');
        if (impersonationUser) sessionStorage.setItem('user', impersonationUser);
        const impersonationPlanTier = sessionStorage.getItem('impersonationPlanTier');
        if (impersonationPlanTier) sessionStorage.setItem('planTier', impersonationPlanTier);
        sessionStorage.removeItem('impersonationToken');
        sessionStorage.removeItem('impersonationUser');
        sessionStorage.removeItem('impersonationPlanTier');
        window.location.href = '/superadmin';
      } else {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default instance;
